import {
  getFinalsLiquidations,
  getGlosses,
  getImportedLiquidationsContainers,
  getPreliminariesLiquidations
} from "@/constants/liquidations";

export default {
  namespaced: true,
  state: {

    //preliminares

    preliminariesLiquidationsData: [],

    preliminariesLiquidationsCustomersDataDatatable: [],
    preliminariesLiquidationsCarriersDataDatatable: [],

    preliminariesLiquidationsCustomersDataDatatableFiltered: [],
    preliminariesLiquidationsCarriersDataDatatableFiltered: [],

    preliminariesLiquidationsCustomersFiltered: false,
    preliminariesLiquidationsCarriersFiltered: false,

    preliminariesLiquidationsShowManageModal: false,
    preliminariesLiquidationsCreateMode: false,
    preliminariesLiquidationsShowFiltersModal: false,
    preliminariesLiquidationsTab: 1,
    currentPreliminaryLiquidationData: [],

    //general

    liquidationShowPreviewModal: false,
    liquidationPreviewData: [],
    liquidationsPodsList: [],
    liquidationsCarriersList: [],
    liquidationsVesselsList: [],
    liquidationsCustomersList: [],
    liquidationsCommoditiesList: [],
    liquidationsDestinationsList: [],

    //finales

    finalsLiquidationsData: [],
    finalsLiquidationsCustomersDataDatatable: [],
    finalsLiquidationsCarriersDataDatatable: [],

    finalsLiquidationsCustomersDataDatatableFiltered: [],
    finalsLiquidationsCarriersDataDatatableFiltered: [],

    finalsLiquidationsCustomersFiltered: false,
    finalsLiquidationsCarriersFiltered: false,

    finalsLiquidationsShowManageModal: false,
    finalsLiquidationsShowMailerModal: false,
    finalsLiquidationsShowNetsuiteModal: false,
    finalsLiquidationsShowBookingsDetailsModal: false,
    currentFinalLiquidationID: false,
    finalsLiquidationsCreateMode: false,
    finalsLiquidationsShowFiltersModal: false,
    finalsLiquidationsTab: 1,
    currentFinalLiquidationData: [],

    //importador

    liquidationsContainersData: [],
    liquidationsContainersDataDatatable: [],
    liquidationsContainersShowManageModal: false,
    liquidationsContainersCreateMode: false,
    liquidationsCurrentContainersData: [],
    liquidationsContainersShowImportModal: false,

    //glosas

    liquidationsGlossesData: [],
    liquidationsGlossesDataDatatable: [],
    liquidationsGlossesShowManageModal: false,
    liquidationsGlossesCreateMode: false,
    liquidationsCurrentGlossData: [],
    liquidationsGlossesShowImportModal: false,
    glossesVendorList: [],
    glossesCustomerList: [],
    glossesItemList: [],
    glossesSubsidiaryList: [],
    glossesCurrencyList: [],
    glossesLocationList: [],
    glossesCustomFormList: [],
    glossesTaxTypeList: [],

    //facturacion
    crTipoDocElect: [],
    crMetodoPago: [],
    crCondicionPago: [],
    crCodOperacion: [],
    peTipoDocumento: [],
    peTipoOperacion: [],
    peFormaPago: [],
    peTipoPago: [],
    peMetodoPago: [],
    chTipoDocumento: [],
    chFechaEmision: "",

    loadingExtraCostos: false,
  },

  mutations: {

    //preliminares

    setShowManageModalPreliminariesLiquidations(state, payload) {
      state.preliminariesLiquidationsShowManageModal = payload;
    },

    setShowFiltersModalPreliminariesLiquidations(state, payload) {
      state.preliminariesLiquidationsShowFiltersModal = payload;
    },

    setCreateModePreliminariesLiquidations(state, payload) {
      state.preliminariesLiquidationsCreateMode = payload;
    },

    setCurrentTabPreliminariesLiquidations(state, payload) {
      state.preliminariesLiquidationsTab = payload;
    },

    async setDataPreliminariesLiquidations(state) {
      state.preliminariesLiquidationsData = await getPreliminariesLiquidations();
    },

    setDataDatatablePreliminariesCustomersLiquidations(state, payload) {
      state.preliminariesLiquidationsCustomersDataDatatable = payload;
    },

    setDataDatatablePreliminariesCarriersLiquidations(state, payload) {
      state.preliminariesLiquidationsCarriersDataDatatable = payload;
    },

    setPreliminariesLiquidationsCustomersDataDatatableFiltered(state, payload) {
      state.preliminariesLiquidationsCustomersDataDatatableFiltered = payload;
    },

    setPreliminariesLiquidationsCarriersDataDatatableFiltered(state, payload) {
      state.preliminariesLiquidationsCarriersDataDatatableFiltered = payload;
    },

    setDataCurrentPreliminaryLiquidation(state, payload) {
      state.currentPreliminaryLiquidationData = payload;
    },

    setDataFilteredCustomersPreliminaryLiquidationFlag(state, payload) {
      state.preliminariesLiquidationsCustomersFiltered = payload;
    },

    setDataFilteredCarriersPreliminaryLiquidationFlag(state, payload) {
      state.preliminariesLiquidationsCarriersFiltered = payload;
    },

    //

    setShowPreviewModalLiquidations(state, payload) {
      state.liquidationShowPreviewModal = payload;
    },

    setDataLiquidationPreview(state, payload) {
      state.liquidationPreviewData = payload;
    },

    setPodsListLiquidations(state, payload) {
      state.liquidationsPodsList = payload;
    },

    setCarriersListLiquidations(state, payload) {
      state.liquidationsCarriersList = payload;
    },

    setVesselsListLiquidations(state, payload) {
      state.liquidationsVesselsList = payload;
    },

    setCustomersListLiquidations(state, payload) {
      state.liquidationsCustomersList = payload;
    },

    setCommoditiesListLiquidations(state, payload) {
      state.liquidationsCommoditiesList = payload;
    },

    setDestinationsListLiquidations(state, payload) {
      state.liquidationsDestinationsList = payload;
    },

    //finales

    setShowManageModalFinalsLiquidations(state, payload) {
      state.finalsLiquidationsShowManageModal = payload;
    },

    setShowFiltersModalFinalsLiquidations(state, payload) {
      state.finalsLiquidationsShowFiltersModal = payload;
    },

    setShowMailerModalFinalsLiquidations(state, payload) {
      state.finalsLiquidationsShowMailerModal = payload;
    },

    setShowNetsuiteModalFinalsLiquidations(state, payload) {
      state.finalsLiquidationsShowNetsuiteModal = payload;
    },

    setShowManageModalBookingsDetailsFinalsLiquidations(state, payload) {
      state.finalsLiquidationsShowBookingsDetailsModal = payload;
    },

    setCurrentFinalLiquidationID(state, payload) {
      state.currentFinalLiquidationID = payload;
    },

    setCreateModeFinalsLiquidations(state, payload) {
      state.finalsLiquidationsCreateMode = payload;
    },

    setCurrentTabFinalsLiquidations(state, payload) {
      state.finalsLiquidationsTab = payload;
    },

    async setDataFinalsLiquidations(state) {
      state.finalsLiquidationsData = await getFinalsLiquidations();
    },

    setDataDatatableFinalsCustomersLiquidations(state, payload) {
      state.finalsLiquidationsCustomersDataDatatable = payload;
    },

    setDataDatatableFinalsCarriersLiquidations(state, payload) {
      state.finalsLiquidationsCarriersDataDatatable = payload;
    },

    setFinalsLiquidationsCustomersDataDatatableFiltered(state, payload) {
      state.finalsLiquidationsCustomersDataDatatableFiltered = payload;
    },

    setFinalsLiquidationsCarriersDataDatatableFiltered(state, payload) {
      state.finalsLiquidationsCarriersDataDatatableFiltered = payload;
    },

    setDataCurrentFinalLiquidation(state, payload) {
      state.currentFinalLiquidationData = payload;
    },

    setDataFilteredCustomersFinalLiquidationFlag(state, payload) {
      state.finalsLiquidationsCustomersFiltered = payload;
    },

    setDataFilteredCarriersFinalLiquidationFlag(state, payload) {
      state.finalsLiquidationsCarriersFiltered = payload;
    },

    //importador

    async setDataLiquidationsContainers(state) {
      state.liquidationsContainersData = await getImportedLiquidationsContainers();
    },

    setDataDatatableLiquidationsContainers(state, payload) {
      state.liquidationsContainersDataDatatable = payload;
    },

    setShowManageModalLiquidationsContainers(state, payload) {
      state.liquidationsContainersShowManageModal = payload;
    },

    setShowImportModalLiquidationsContainers(state, payload) {
      state.liquidationsContainersShowImportModal = payload;
    },

    setCreateModeLiquidationsContainers(state, payload) {
      state.liquidationsContainersCreateMode = payload;
    },

    setCurrentLiquidationsContainerData(state, payload) {
      state.liquidationsCurrentContainersData = payload;
    },

    //glosas

    async setDataLiquidationsGlosses(state) {
      state.liquidationsGlossesData = await getGlosses();
    },

    setDataDatatableLiquidationsGlosses(state, payload) {
      state.liquidationsGlossesDataDatatable = payload;
    },

    setShowManageModalLiquidationsGlosses(state, payload) {
      state.liquidationsGlossesShowManageModal = payload;
    },

    setShowImportModalLiquidationsGlosses(state, payload) {
      state.liquidationsGlossesShowImportModal = payload;
    },

    setCreateModeLiquidationsGlosses(state, payload) {
      state.liquidationsGlossesCreateMode = payload;
    },

    setCurrentLiquidationsGlossData(state, payload) {
      state.liquidationsCurrentGlossData = payload;
    },

    //listas

    setGlossesCustomerList(state, payload) {
      state.glossesCustomerList = payload;
    },

    setGlossesItemList(state, payload) {
      state.glossesItemList = payload;
    },

    setGlossesSubsidiaryList(state, payload) {
      state.glossesSubsidiaryList = payload;
    },

    setGlossesCurrencyList(state, payload) {
      state.glossesCurrencyList = payload;
    },

    setGlossesVendorList(state, payload) {
      state.glossesVendorList = payload;
    },

    setGlossesTaxTypeList(state, payload) {
      state.glossesTaxTypeList = payload;
    },

    setGlossesLocationList(state, payload) {
      state.glossesLocationList = payload;
    },

    setGlossesCustomFormList(state, payload) {
      state.glossesCustomFormList = payload;
    },

    // Costa Rica
    setCrTipoDocElect(state, payload) {
      state.crTipoDocElect = payload;
    },
    setCrMetodoPago(state, payload) {
      state.crMetodoPago = payload;
    },
    setCrCondicionPago(state, payload) {
      state.crCondicionPago = payload;
    },
    setCrCodOperacion(state, payload) {
      state.crCodOperacion = payload;
    },

    // Perú
    setPeTipoDocumento(state, payload) {
      state.peTipoDocumento = payload;
    },
    setPeTipoOperacion(state, payload) {
      state.peTipoOperacion = payload;
    },
    setPeFormaPago(state, payload) {
      state.peFormaPago = payload;
    },
    setPeTipoPago(state, payload) {
      state.peTipoPago = payload;
    },
    setPeMetodoPago(state, payload) {
      state.peMetodoPago = payload;
    },

    // Chile
    setChTipoDocumento(state, payload) {
      state.chTipoDocumento = payload;
    }

  },

  actions: {

    //preliminares

    actionSetDataPreliminariesLiquidations({ commit }, data) {
      commit("setDataPreliminariesLiquidations", data);
    },

    actionSetDataDatatableCustomersPreliminariesLiquidations({ commit }, data) {
      commit("setDataDatatablePreliminariesCustomersLiquidations", data);
    },

    actionSetDataDatatableCarriersPreliminariesLiquidations({ commit }, data) {
      commit("setDataDatatablePreliminariesCarriersLiquidations", data);
    },

    actionSetDataDatatableCustomersFilteredPreliminariesLiquidations({ commit }, data) {
      commit("setPreliminariesLiquidationsCustomersDataDatatableFiltered", data);
    },

    actionSetDataDatatableCarriersFilteredPreliminariesLiquidations({ commit }, data) {
      commit("setPreliminariesLiquidationsCarriersDataDatatableFiltered", data);
    },

    actionSetCreateModePreliminariesLiquidations({ commit }, data) {
      commit("setCreateModePreliminariesLiquidations", data);
    },

    actionSetCurrentTabPreliminariesLiquidations({ commit }, data) {
      commit("setCurrentTabPreliminariesLiquidations", data);
    },

    actionSetShowManageModalPreliminariesLiquidations({ commit }, data) {
      commit("setShowManageModalPreliminariesLiquidations", data);
    },

    actionSetShowFiltersModalPreliminariesLiquidations({ commit }, data) {
      commit("setShowFiltersModalPreliminariesLiquidations", data);
    },

    actionSetDataCurrentPreliminaryLiquidation({ commit }, data) {
      commit("setDataCurrentPreliminaryLiquidation", data);
    },

    actionSetFlagCustomersPreliminaryLiquidationFiltered({ commit }, data) {
      commit("setDataFilteredCustomersPreliminaryLiquidationFlag", data);
    },

    actionSetFlagCarriersPreliminaryLiquidationFiltered({ commit }, data) {
      commit("setDataFilteredCarriersPreliminaryLiquidationFlag", data);
    },

    //

    actionSetShowPreviewModalLiquidations({ commit }, data) {
      commit("setShowPreviewModalLiquidations", data);
    },

    actionSetDataLiquidationPreview({ commit }, data) {
      commit("setDataLiquidationPreview", data);
    },

    actionSetPodsListLiquidations({ commit }, data) {
      commit("setPodsListLiquidations", data);
    },

    actionSetVesselsListLiquidations({ commit }, data) {
      commit("setVesselsListLiquidations", data);
    },

    actionSetCarriersListLiquidations({ commit }, data) {
      commit("setCarriersListLiquidations", data);
    },

    actionSetCustomersListLiquidations({ commit }, data) {
      commit("setCustomersListLiquidations", data);
    },

    actionSetCommoditiesListLiquidations({ commit }, data) {
      commit("setCommoditiesListLiquidations", data);
    },

    actionSetDestinationsListLiquidations({ commit }, data) {
      commit("setDestinationsListLiquidations", data);
    },

    //finales

    actionSetDataFinalsLiquidations({ commit }, data) {
      commit("setDataFinalsLiquidations", data);
    },

    actionSetDataDatatableCustomersFinalsLiquidations({ commit }, data) {
      commit("setDataDatatableFinalsCustomersLiquidations", data);
    },

    actionSetDataDatatableCarriersFinalsLiquidations({ commit }, data) {
      commit("setDataDatatableFinalsCarriersLiquidations", data);
    },

    actionSetDataDatatableCustomersFilteredFinalsLiquidations({ commit }, data) {
      commit("setFinalsLiquidationsCustomersDataDatatableFiltered", data);
    },

    actionSetDataDatatableCarriersFilteredFinalsLiquidations({ commit }, data) {
      commit("setFinalsLiquidationsCarriersDataDatatableFiltered", data);
    },

    actionSetCurrentTabFinalsLiquidations({ commit }, data) {
      commit("setCurrentTabFinalsLiquidations", data);
    },

    actionSetShowManageModalFinalsLiquidations({ commit }, data) {
      commit("setShowManageModalFinalsLiquidations", data);
    },

    actionSetShowFiltersModalFinalsLiquidations({ commit }, data) {
      commit("setShowFiltersModalFinalsLiquidations", data);
    },

    actionSetShowMailerModalFinalsLiquidations({ commit }, data) {
      commit("setShowMailerModalFinalsLiquidations", data);
    },

    actionSetShowNetsuiteModalFinalsLiquidations({ commit }, data) {
      commit("setShowNetsuiteModalFinalsLiquidations", data);
    },

    actionSetShowManageModalBookingsDetailsFinalsLiquidations({ commit }, data) {
      commit("setShowManageModalBookingsDetailsFinalsLiquidations", data);
    },

    actionSetCurrentFinalLiquidationID({ commit }, data) {
      commit("setCurrentFinalLiquidationID", data);
    },


    actionSetDataCurrentFinalLiquidation({ commit }, data) {
      commit("setDataCurrentFinalLiquidation", data);
    },

    actionSetFlagCustomersFinalLiquidationFiltered({ commit }, data) {
      commit("setDataFilteredCustomersFinalLiquidationFlag", data);
    },

    actionSetFlagCarriersFinalLiquidationFiltered({ commit }, data) {
      commit("setDataFilteredCarriersFinalLiquidationFlag", data);
    },

    actionSetCreateModeFinalsLiquidations({ commit }, data) {
      commit("setCreateModeFinalsLiquidations", data);
    },

    //importador

    actionSetDataLiquidationsContainers({ commit }, data) {
      commit("setDataLiquidationsContainers", data);
    },

    actionSetDataDatatableLiquidationsContainers({ commit }, data) {
      commit("setDataDatatableLiquidationsContainers", data);
    },

    actionSetShowManageModalLiquidationsContainers({ commit }, data) {
      commit("setShowManageModalLiquidationsContainers", data);
    },

    actionSetShowImportModalLiquidationsContainers({ commit }, data) {
      commit("setShowImportModalLiquidationsContainers", data);
    },

    actionSetCreateModeLiquidationsContainers({ commit }, data) {
      commit("setCreateModeLiquidationsContainers", data);
    },

    actionSetCurrentLiquidationsContainerData({ commit }, data) {
      commit("setCurrentLiquidationsContainerData", data);
    },

    //glosas

    actionSetDataLiquidationsGlosses({ commit }, data) {
      commit("setDataLiquidationsGlosses", data);
    },

    actionSetDataDatatableLiquidationsGlosses({ commit }, data) {
      commit("setDataDatatableLiquidationsGlosses", data);
    },

    actionSetShowManageModalLiquidationsGlosses({ commit }, data) {
      commit("setShowManageModalLiquidationsGlosses", data);
    },

    actionSetShowImportModalLiquidationsGlosses({ commit }, data) {
      commit("setShowImportModalLiquidationsGlosses", data);
    },

    actionSetCreateModeLiquidationsGlosses({ commit }, data) {
      commit("setCreateModeLiquidationsGlosses", data);
    },

    actionSetCurrentLiquidationsGlossData({ commit }, data) {
      commit("setCurrentLiquidationsGlossData", data);
    },

    //listas
    actionSetGlossesCustomerList({ commit }, data) {
      commit("setGlossesCustomerList", data);
    },

    actionSetGlossesItemList({ commit }, data) {
      commit("setGlossesItemList", data);
    },

    actionSetGlossesSubsidiaryList({ commit }, data) {
      commit("setGlossesSubsidiaryList", data);
    },

    actionSetGlossesVendorList({ commit }, data) {
      commit("setGlossesVendorList", data);
    },

    actionSetGlossesCurrencyList({ commit }, data) {
      commit("setGlossesCurrencyList", data);
    },

    actionSetGlossesTaxTypeList({ commit }, data) {
      commit("setGlossesTaxTypeList", data);
    },

    actionSetGlossesCustomFormList({ commit }, data) {
      commit("setGlossesCustomFormList", data);
    },

    actionSetGlossesLocationList({ commit }, data) {
      commit("setGlossesLocationList", data);
    },

    //CR
    actionSetCrTipoDocElect({ commit }, data) {
      commit("setCrTipoDocElect", data);
    },
    actionSetCrMetodoPago({ commit }, data) {
      commit("setCrMetodoPago", data);
    },
    actionSetCrCondicionPago({ commit }, data) {
      commit("setCrCondicionPago", data);
    },
    actionSetCrCodOperacion({ commit }, data) {
      commit("setCrCodOperacion", data);
    },

    //Perú
    actionSetPeTipoDocumento({ commit }, data) {
      commit("setPeTipoDocumento", data);
    },
    actionSetPeTipoOperacion({ commit }, data) {
      commit("setPeTipoOperacion", data);
    },
    actionSetPeFormaPago({ commit }, data) {
      commit("setPeFormaPago", data);
    },
    actionSetPeTipoPago({ commit }, data) {
      commit("setPeTipoPago", data);
    },
    actionSetPeMetodoPago({ commit }, data) {
      commit("setPeMetodoPago", data);
    },

    //CH
    actionSetChTipoDocumento({ commit }, data) {
      commit("setChTipoDocumento", data);
    },

  }

};
